import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_bt26xm3nnw: FaireCollectionEntity = {
  token: "pbc_bt26xm3nnw",
  type: "collection",
  name: "Bear Organic Baby Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c9c550bfd6d8fd3cb404cb133789b969d0528017769c93aeb5a3f746ed000e9e.jpeg",
  itemCount: 27,
  description:
    "A playful bear-themed collection, ethically made in India with soft organic cotton for everyday comfort and smiles.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:20.883Z",
    importedBy: "entity-db-import-collections",
  },
};
